<template>
  <div class="config-app">
    <h2 class="app-title">Financeiro</h2>
    <p class="subtitle">Permite você habilitar e configurar as preferências do módulo financeiro.</p>

    <app-tab :active="active" :menu="menu" @changeTab="(item) => active = item.name">
      <div v-if="active === 'basico'" class="app-input-container">
      </div>
      <list-formas-pagamento v-if="active === 'formas-pagamento'" class="app-input-container" />
    </app-tab>
  </div>
</template>

<script>
import AppMixin from './appMixin'
import ListFormasPagamento from "@/components/cadastro/components/formaspagamento/List"

export default {
  name: "ConfigFinanceiro",
  components: {
    ListFormasPagamento
  },
  mixins: [AppMixin],
  data() {
    return {
      active: 'basico'
    }
  },
  computed: {
    menu() {
      return [
        {
          name: 'basico',
          label: 'Básico'
        },
        {
          name: 'formas-pagamento',
          label: 'Formas de Pagamento'
        }
      ]
    }
  }
}
</script>
